import { Paper } from "@material-ui/core";
import React from "react";
import DbtResearchProjectMain from "./DbtResearchProjectMain";

export default function DbtResearchProjectLanding({ apikey, username, role, history }) {
  return (
    <div>
      <div style={{ paddingTop: 10 }}>
        <Paper square>
          <DbtResearchProjectMain apikey={apikey} />
        </Paper>
      </div>
    </div>
  );
}
